import Vue from 'vue'
import VueRouter from 'vue-router'

import './assets/css/tailwind.css'
import App from './App'
import {
  ValidationObserver,
  ValidationProvider,
  extend
} from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'
import GlobalComponents from './globalComponents'

import firebase from 'firebase/compat/app'
import router from './router'
import { store } from './store'
import './filters'

Vue.config.productionTip = false

Vue.use(VueRouter)
Vue.use(GlobalComponents)

// Install VeeValidate rules and localization
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule])
})

Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)

// A secondary Vue instance to communicate between components.
var EventHolder = new Vue()
Vue.prototype.EventHolder = EventHolder

/* eslint-disable no-new */
let app
firebase.auth().onAuthStateChanged((user) => {
  if (user) {
    store.dispatch('AUTO_SIGN_IN', user)
  }
  if (!app) {
    app = new Vue({
      el: '#app',
      router,
      store,
      render (h) {
        return h(App)
      }
    })
  }
})
